import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ContactUS } from '../data-models/contact-us';
import { Observable } from 'rxjs';
import { ApiResponse } from '../data-models/api-response';
@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  private baseUrl: string | undefined;

  constructor(private _http: HttpClient,) {
    this.baseUrl = environment.apiUrl;
  }

  ContactUs(model: ContactUS): Observable<ApiResponse<null>> {
    const formData = new FormData();
    formData.append('name', model.name);
    formData.append('phone', model.phone);
    formData.append('email', model.email);
    formData.append('message', model.message);
    return this._http.post<ApiResponse<null>>(`${this.baseUrl}/client/contact-us`, formData);
  }





  socialMedia(){
    return this._http.get<ApiResponse<null>>(`${this.baseUrl}/client/social-media`);
  }
  settings(){
    return this._http.get<ApiResponse<null>>(`${this.baseUrl}/client/settings`);
  }

}
